import Welcome from './Welcome.vue';
import SignatureProcess from './SignatureProcess.vue';
import SignatureSingleStep from './SignatureSingleStep.vue';

import Successfull from './Successfull.vue';

import messages from '@/locales/languages/qes';

const BASE_ROUTE = '/QES/';

export const routes = {
  BASE_ROUTE: BASE_ROUTE,
  ROUTE_SIGNATURE_PROCESS: 'SignatureProcess',
  ROUTE_SIGNATURE_SINGLE_STEP: 'SignatureSingleStep',

  ROUTE_SUCCESS: 'Success',
};

export const children = [
  // UserHome will be rendered inside User's <router-view>
  // when /user/:id is matched
  {
    name: routes.BASE_ROUTE,
    path: '/',
    component: Welcome,
    meta: {
      i18n: messages,
    },
  },
  {
    name: BASE_ROUTE + routes.ROUTE_SIGNATURE_PROCESS,
    path: routes.ROUTE_SIGNATURE_PROCESS,
    component: SignatureProcess,
    meta: {
      i18n: messages,
    },
  },
  {
    name: BASE_ROUTE + routes.ROUTE_SIGNATURE_SINGLE_STEP,
    path: routes.ROUTE_SIGNATURE_SINGLE_STEP,
    component: SignatureSingleStep,
    meta: {
      i18n: messages,
    },
  },
  {
    name: BASE_ROUTE + routes.ROUTE_SUCCESS,
    path: routes.ROUTE_SUCCESS,
    component: Successfull,
    meta: {
      i18n: messages,
    },
  },

  // ...other sub routes
];
